module.exports = __webpack_public_path__ + "img/selected5-min.a8dfc1a0.png";